
import { Divider, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import InstituteBasics from '../manage-institute/instituteBasics';
import BasicInfoTrustForm from './trust/basicInfoTrustForm';
import BomComposition from './trust/bomComposition';
import CommitteeMeetingsPage from '../manage-committee/committee-meeting/committeeMeetings.page';
import MatSelect from '../common/matSelect';
import CustomTabs from '../common/customTabs';

const SynizaTrust = () => {

    const [option, setOption] = useState(null)
    const [selected, setSelected] = useState("")
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get('tab');
        if (param)
            setSelected(param);
        else
            setSelected("basicinfo")
    }, []);
    function handleAcademicYear(event) {
        console.log("event:", event);
    }
    // let option;
    function onClick(name) {
        console.log("name trust info:", name);
        setSelected(name);
        setOption(getItem(name));
    }

    function getItem(name) {
        switch (name) {
            case "basicinfo":
                return <BasicInfoTrustForm />
            case "composition":
                return <BomComposition />
            case "scheduleMeeting":
                return <CommitteeMeetingsPage committee={"BOM"} />
            case "addinstitute":
                return <InstituteBasics />
            default:
                break;
        }
    }

    function getTabs() {
        return [
            {
                name: "basicinfo", label: "Basic Info"
            },
            {
                name: "composition", label: "Composition"
            },
            {
                name: "scheduleMeeting", label: "BoM Meetings"
            },
            {
                name: "addinstitute", label: "Add Institutions"
            }
        ]
    }


   

    return (
        <>
            <Grid container columnSpacing={2}>
            
                {/* {getTabs().map(tab => <Grid item sm={12} md={3}>
                    {tab.name === selected ? <Button className='tabs' color='default' fullWidth variant='contained' onClick={() => onClick(tab.name)}> {tab.label} </Button> : <Button className='tabs' color='outlinedDefault' fullWidth variant='outlined' onClick={() => onClick(tab.name)}> {tab.label} </Button>}
                </Grid>)} */}
                <CustomTabs tabs={getTabs()} selected={selected} onClick={onClick} cols={3} />

            </Grid>
            <br />
            <Divider />
            <br />
           {/* <Grid container item sm={12}>
           <MatTabs items={[{label:"Tab 1",index:"1"}]} />
           </Grid> */}
            <Grid container item sm={3}>
                <MatSelect label={"Academic Year"} value={"2024-25"} onChange={handleAcademicYear} options={[{ id: "2023-24", name: "2023-24" }, { id: "2024-25", name: "2024-25" }]} />
            </Grid>
            <br />
            <Grid container item sm={12}>
                {getItem(selected)}
            </Grid>
        </>
    );
}

export default SynizaTrust;